import {
  PreventiveMaintenancePartsApi,
  PreventiveMaintenancePlanAssetsApi,
  PreventiveMaintenancePlanTasksApi,
  PreventiveMaintenancePlansApi,
  PreventiveMaintenanceSchedulesApi,
  PreventiveMaintenanceTasksApi,
  PreventiveMaintenanceTriggersApi,
  PreventiveMaintenanceWorkTypesApi,
} from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const plansApi = new PreventiveMaintenancePlansApi(config);
export const tasksApi = new PreventiveMaintenanceTasksApi(config);
export const triggersApi = new PreventiveMaintenanceTriggersApi(config);
export const partsApi = new PreventiveMaintenancePartsApi(config);
export const workTypesApi = new PreventiveMaintenanceWorkTypesApi(config);
export const planTasksApi = new PreventiveMaintenancePlanTasksApi(config);
export const planAssetsApi = new PreventiveMaintenancePlanAssetsApi(config);
export const schedulesApi = new PreventiveMaintenanceSchedulesApi(config);

export const pmRequestInit = { credentials: 'include' as const };
